import { render, staticRenderFns } from "./TwoStepVerificationComponent.vue?vue&type=template&id=73aa8226"
import script from "./TwoStepVerificationComponent.vue?vue&type=script&lang=js"
export * from "./TwoStepVerificationComponent.vue?vue&type=script&lang=js"
import style0 from "./TwoStepVerificationComponent.vue?vue&type=style&index=0&id=73aa8226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports